import { render, staticRenderFns } from "./addGift.vue?vue&type=template&id=1e8ac599&scoped=true&"
import script from "./addGift.vue?vue&type=script&lang=ts&"
export * from "./addGift.vue?vue&type=script&lang=ts&"
import style0 from "./addGift.vue?vue&type=style&index=0&id=1e8ac599&lang=scss&scoped=true&"
import style1 from "./addGift.vue?vue&type=style&index=1&id=1e8ac599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8ac599",
  null
  
)

export default component.exports